module.exports = {"index":{"meta":{"title":"Bestsellers","description":"The bestsellers provided by :%shopname%"}}};